import { FormBoolean } from '../project-settings-form/form';
import { FormOneOf } from '../project-settings-form/form-schema';

/**
 * Converts a FormBoolean type to the oneOf syntax used in RJSF schemas.
 * Returns an array with 'Yes' and 'No' options.
 */
export function formBooleanToOneOf(): Array<FormOneOf<FormBoolean>> {
  return [
    {
      type: 'string',
      title: 'Yes',
      enum: ['yes']
    },
    {
      type: 'string',
      title: 'No',
      enum: ['no']
    }
  ];
}
